import React from "react"
import slugify from "slugify"
import clsx from "clsx"

import { Asset, Button, Decorator, IconButton, RichText } from "components"

function Actions({ heroButton, content, heroVideo, heroImage, className }) {
  let jumpLinks = []
  // extract jumpLinks from content
  content?.forEach(({ __typename, content, header, heading, title }, i) => {
    switch (__typename) {
      case "ContentfulAccordion":
      case "ContentfulCollage":
      case "ContentfulColumnGrid":
      case "ContentfulRichText":
      case "ContentfulSectionHeader":
      case "ContentfulTextBlock":
      case "ContentfulTimeline":
      case "ContentfulSideBySide":
      case "ContentfulStatGrid":
        {
          // extract ID from content, if relevant
          let id = ""
          let label = ""
          if (content?.raw) {
            let contentParsed = JSON.parse(content.raw)
            if (
              contentParsed?.content &&
              contentParsed?.content[0]?.nodeType?.startsWith("heading")
            ) {
              id = slugify(contentParsed?.content[0]?.content[0]?.value)
              label = contentParsed?.content[0]?.content[0]?.value
            }
          }
          if (title || header || heading) {
            label = title || (header?.heading ? header.heading : heading)
            id = slugify(title || (header?.heading ? header.heading : heading))
          }
          if (id && label) {
            jumpLinks.push({ link: id, label: label })
          }
        }
        break
      default:
        return null
    }
  })
  return (
    <div className={clsx("space-y-8", className)}>
      {heroButton && (
        <div className="lg:text-left text-center">
          <Button
            label={heroButton.label}
            href={heroButton.link?.link}
            appearance="primary"
            size="large"
          />
        </div>
      )}
      {(heroVideo || heroImage) && (
        <ul className="space-y-6">
          {jumpLinks?.map(({ label, link }, i) => {
            return (
              <li key={`heroNavLink-${i}`}>
                <IconButton
                  label={label}
                  href={"#" + link}
                  icon="arrow-down"
                  animate="down"
                />
              </li>
            )
          })}
        </ul>
      )}
    </div>
  )
}

function Hero({
  content,
  heroButton,
  heroContent,
  heroDecorator,
  heroHeader,
  heroImage,
  heroVideo,
}) {
  if (heroHeader) {
    return (
      <header className="md:pt-20 md:overflow-visible wrapper default-grid gap-y-8 lg:gap-y-14 lg:pb-24 pt-8 pb-8 overflow-hidden">
        <div className="col-span-full lg:col-span-8 space-y-8">
          <div className="space-y-6">
            {heroHeader && <h1 className="h1 text-darkPurple">{heroHeader}</h1>}
            {heroContent && (
              <RichText
                className="max-w-xl"
                content={heroContent}
                size="large"
              />
            )}
          </div>
          <Actions
            className="lg:block hidden"
            heroButton={heroButton}
            content={content}
            heroVideo={heroVideo}
            heroImage={heroImage}
          />
        </div>
        {heroImage && (
          <div className="lg:col-span-3 col-span-full lg:col-start-10">
            <div className="lg:-mr-26">
              <div className="aspect-w-1 aspect-h-1 select-none">
                <Asset
                  asset={heroImage}
                  objectFit="contain"
                  objectPosition={heroVideo ? "right" : "center"}
                  style={{ position: "absolute" }}
                />
                {heroDecorator && (
                  <div>
                    <Decorator
                      className="-translate-x-7 md:-translate-x-1/2 bottom-4 md:left-4 lg:block absolute left-0 hidden translate-y-1/2"
                      asset={heroDecorator.asset}
                      size="small"
                    />
                  </div>
                )}
              </div>
            </div>
          </div>
        )}
        <Actions
          className="col-span-full lg:hidden block"
          heroButton={heroButton}
          content={content}
          heroVideo={heroVideo}
          heroImage={heroImage}
        />
      </header>
    )
  } else return null
}

export default Hero
